import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {CardTagSelection, CardTagSelectionTagType} from '@dms/shared';

import {VehicleCatalogueFeature} from '../../../../../../types/VehicleCatalogueFeature';

interface HighlightedFeaturesCardProps {
  featureItems: Array<VehicleCatalogueFeature & {isPremium?: boolean}>;
  highlightedFeatures: string[];
  isReadOnly?: boolean;
  onHighlightOnBulk: (keys: string[]) => void;
  onHighlightOff: (key: string) => void;
  onHighlightOffBulk: (key: string[]) => void;
}

export function HighlightedFeaturesCard({
  featureItems = [],
  highlightedFeatures,
  isReadOnly = false,
  onHighlightOnBulk,
  onHighlightOff,
  onHighlightOffBulk,
}: HighlightedFeaturesCardProps) {
  const removeFeatureHighlight = (tag: CardTagSelectionTagType) => {
    onHighlightOff(tag.id);
  };

  const removeFeatureHighlightBulk = (tags: CardTagSelectionTagType[]) => {
    onHighlightOffBulk(tags.map((item) => item.id));
  };

  const addFeatureHighlight = (tags: CardTagSelectionTagType[]) => {
    onHighlightOnBulk(tags.map((item) => item.id));
  };

  const highlightedItems = featureItems
    .filter((item) => (item.key ? highlightedFeatures.includes(item.key) : false))
    .map(
      (item) =>
        ({
          id: item.key,
          label: item.isPremium ? `★ ${item.name}` : item.name,
        }) as CardTagSelectionTagType
    )
    .sort(
      (a, b) =>
        highlightedFeatures.indexOf(a.id as string) - highlightedFeatures.indexOf(b.id as string)
    );

  return (
    <CardTagSelection
      tags={highlightedItems}
      predefinedTags={featureItems.map(
        (i) =>
          ({
            id: i.key,
            label: i.name,
          }) as CardTagSelectionTagType
      )}
      onDelete={removeFeatureHighlight}
      onDeleteBulk={removeFeatureHighlightBulk}
      onCreateBulk={addFeatureHighlight}
      data-testid={testIds.vehicles.detail('topHighlightedFeatures')}
      title={i18n.t('entity.vehicle.labels.highlightedFeatures')}
      editDialogTitle={i18n.t('entity.vehicle.labels.highlightedFeatures')}
      emptyMessage={i18n.t('entity.vehicle.labels.highlightedFeaturesPlaceholder')}
      tagsColorScheme="blue"
      isCreationDisabled
      isDisabled={isReadOnly}
    />
  );
}
